import React, { useRef, useEffect, useState } from "react";
import { DateRange } from "react-date-range";
import { addYears, isEqual, isValid, parse } from "date-fns";
import useOutsideClick from "../UseOutsideClick";
import DateHelper from "../DateHelper/DateHelper";

export default function DateRangePicker(props) {
  const wrapperRef = useRef();
  const dialogRef = useRef();
  const startDateWrapperRef = useRef();
  const endDateWrapperRef = useRef();
  const [isVisible, setIsVisible] = useState(false);
  const [focusedRange, setFocusedRange] = useState([0, 0]);

  const [dates, setDates] = useState([
    {
      startDate: props.startDate,
      endDate: props.endDate,
      key: "selection",
    },
  ]);

  const [tempDates, setTempDates] = useState(dates);
  const [{ startDate, endDate }] = dates;
  const [{ startDate: tempStartDate, endDate: tempEndDate }] = tempDates;

  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  const { color = "#FF6600" } = props;

  const minDate =
    typeof props.minDate === "undefined"
      ? new Date()
      : parse(props.minDate, "yyyy-MM-dd", new Date());
  const maxDate =
    typeof props.maxDate !== "undefined"
      ? parse(props.maxDate, "yyyy-MM-dd", new Date())
      : addYears(minDate, 1);
  const validDates = (() => {
    if (!isValid(tempStartDate) || !isValid(tempEndDate)) {
      return false;
    } else if (isEqual(tempStartDate, tempEndDate)) {
      return false;
    }
    return true;
  })();

  useEffect(() => {
    if (startDate != props.startDate || endDate != props.endDate) {
      setDates([
        {
          startDate: props.startDate,
          endDate: props.endDate,
          key: "selection",
        },
      ]);
    }
    if (isMobile) {
      $(dialogRef.current)
        .find(".rdrMonth")
        .width($(window).width() - 20);

      }
    if (props.componentVisisibleAction){
      props.componentVisisibleAction(isVisible);
    }
  });

  const setDatesIfValidOrReset = () => {
    if (validDates) {
      setDates([{ startDate: tempStartDate, endDate: tempEndDate }]);
      props.onChange(tempStartDate, tempEndDate);
    } else {
      setTempDates([{ startDate: startDate, endDate: endDate }]);
      props.onChange(startDate, endDate);
    }
  };

  useOutsideClick(wrapperRef, () => {
    if (isVisible) {
      setIsVisible(false);
      setDatesIfValidOrReset();
    }
  });

  const onClickStartDate = (e) => {
    e.preventDefault();
    if (isMobile) {
      parent.window.postMessage("max-exp|hide_title_bar");
    }
    setFocusedRange([0, 0]); // focuses start date
    setIsVisible(true);
  };

  const onClickEndDate = (e) => {
    e.preventDefault();
    if (isMobile) {
      parent.window.postMessage("max-exp|hide_title_bar");
    }
    setFocusedRange([0, 1]); // focuses end date
    setIsVisible(true);
  };

  const onChange = (item) => {
    var { selection } = item;
    const { range1 } = item;
    if (range1) {
      selection = range1;
    }
    const { startDate, endDate } = selection;

    if (isEqual(startDate, endDate)) {
      setTempDates([{ startDate: startDate, endDate: new Date("") }]);
    } else {
      // dates are valid
      setTempDates([selection]);
    }
  };

  const onDone = () => {
    if (isMobile) {
      parent.window.postMessage("max-exp|show_title_bar");
    }
    setIsVisible(false);
    setDatesIfValidOrReset();
  };

  const onReset = () => {
    setTempDates([{ startDate: null, endDate: new Date("") }]);
  };

  const getBottom = () => {
    const dialogHeight = $(dialogRef.current).height();
    const startStartHeight = $(startDateWrapperRef.current).height();
    return dialogHeight - startStartHeight;
  };

  return (
    <div
      ref={wrapperRef}
      style={{ position: "relative" }}
      className={
        props.pickerClasses
          ? "flexed DateRangePicker " + props.pickerClasses
          : "flexed DateRangePicker"
      }
    >
      <div className="col-sm-6 start-date-wrapper" ref={startDateWrapperRef}>
        <label style={props.skip_label_style ? null : { position: "relative", top: "6px", fontSize: "12px" } }>
          {I18n.t(props.startDateLabel)}
        </label>
        <input
          onClick={onClickStartDate}
          inputMode="none"
          type="text"
          name="date-range-picker-start-date"
          className="form-control"
          onChange={() => {}}
          value={
            isValid(startDate)
              ? DateHelper.printDateToScreen(startDate, props.dateFormat)
              : ""
          }
        />

       {props.onToggleDate ? <a href="#" onClick={props.onToggleDate.bind(null, false)}>+{I18n.t('item_date')}</a> : null} 

      </div>
      
      {/* { !props.daily ?
       <div className="col-sm-6 end-date-wrapper" ref={endDateWrapperRef}>
          <label style={props.skip_label_style ? null : { position: "relative", top: "6px", fontSize: "12px" } }>
            {I18n.t(props.endDateLabel)}
          </label>
          <input
            onClick={onClickEndDate}
            inputMode="none"
            type="text"
            name="date-range-picker-end-date"
            className="form-control"
            onChange={() => {}}
            value={
              isValid(endDate)
                ? DateHelper.printDateToScreen(endDate, props.dateFormat)
                : ""
            }
          />
      </div>  
       : null} */}

      <div className="col-sm-6 end-date-wrapper" ref={endDateWrapperRef}>
        <label style={props.skip_label_style ? null : { position: "relative", top: "6px", fontSize: "12px" } }>
          {I18n.t(props.endDateLabel)}
        </label>
        <input
          onClick={onClickEndDate}
          inputMode="none"
          type="text"
          name="date-range-picker-end-date"
          className="form-control"
          onChange={() => {}}
          value={
            isValid(endDate)
              ? DateHelper.printDateToScreen(endDate, props.dateFormat)
              : ""
          }
        />
      </div>

      <div
        ref={dialogRef}
        style={{
          position: isMobile ? "fixed" : "absolute",
          left: isMobile ? "0px" : "10px",
          right: isMobile ? "0px" : "auto",
          top: isMobile ? "0px" : "auto",
          bottom: isMobile ? "0px" : `-${getBottom()}px`,
          zIndex: 1010,
          background: "#FFF",
          display: isVisible ? "block" : "none",
          boxShadow: "0 2px 11px rgba(0,0,0,0.27)",
        }}
        className="date-range-picker-dialog"
      >
        {isMobile ? (
          <div style={{ float: "left", padding: "10px 10px 0 10px" }}>
            <button className="close" onClick={onDone}>
              <svg style={{ height: "24px", width: "24px" }}>
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"></path>
              </svg>
            </button>
          </div>
        ) : null}
        <DateRange
          dateDisplayFormat={DateHelper.rubyToDateFNS(props.dateFormat)}
          editableDateInputs={true}
          onChange={onChange}
          minDate={minDate}
          maxDate={maxDate}
          moveRangeOnFirstSelection={false}
          preventSnapRefocus={true}
          ranges={tempDates}
          months={isMobile ? 1 : 2}
          startDatePlaceholder={props.startDatePlaceholder ? props.startDatePlaceholder : I18n.t("check_in")}
          endDatePlaceholder={props.endDatePlaceholder ? props.endDatePlaceholder : I18n.t("check_out")}
          direction={isMobile ? "vertical" : "horizontal"}
          focusedRange={focusedRange}
          rangeColors={[color, color, color]}
          onRangeFocusChange={(range) => {
            setFocusedRange(range);
          }}
        />
        <div
          style={{
            textAlign: "right",
            position: isMobile ? "absolute" : "static",
            right: "10px",
            bottom: "15px",
            padding: isMobile ? "0px" : "10px 10px 10px 0",
            backgroundColor: "#FFF",
          }}
        >
          {/* <button type="button" className="btn btn-link" onClick={onReset}>
            {I18n.t("reset")}
          </button> */}
          <button
            type="button"
            className="btn btn-primary"
            disabled={!validDates}
            onClick={onDone}
          >
            {I18n.t("select")}
          </button>
        </div>
      </div>
    </div>
  );
}
